import { callApi } from '@/api/api.config';
import { SECURE_USER_GROUPS_KEY } from '@/api/api.constants';
import { prepareSlug } from '@/utils/string.utils';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';

export async function getOtp(email: string, password: string) {
  try {
    return await callApi({
      url: '/api/otp/challenge/',
      method: 'POST',
      data: {
        email,
        password,
      },
    });
  } catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
}

export async function login(email: string, password: string, otp: string) {
  try {
    const response = await callApi({
      url: '/api/token/',
      method: 'POST',
      data: {
        email,
        password,
        otp,
      },
    });

    secureLocalStorage.setItem(
      SECURE_USER_GROUPS_KEY,
      response.data.groups.map((group: string) => prepareSlug(group))
    );
    secureLocalStorage.setItem('token', response.data.access);
    secureLocalStorage.setItem('refresh_token', response.data.refresh);

    return response;
  } catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
}

export function logout(): void {
  try {
    secureLocalStorage.removeItem('token');
    secureLocalStorage.removeItem('refresh_token');
    secureLocalStorage.removeItem(SECURE_USER_GROUPS_KEY);
  } catch (error) {
    console.error('Failed to log out:', error);
  }
}

export async function refreshAccessToken(refreshToken: string) {
  // Fresh instance of axios to avoid infinite hook with interceptors
  const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URI,
  });

  try {
    const response = await api.post('api/token/refresh/', {
      refresh: refreshToken,
    });

    secureLocalStorage.setItem('token', response.data.access);
    return response.data.access;
  } catch (error) {
    console.error('Token refresh failed:', error);

    if (error) {
      logout();
      window.location.href = '/login';
    }

    throw error;
  }
}

export function isLoggedIn(): boolean {
  const token = secureLocalStorage.getItem('token');
  return !!token;
}
